<template>
  <div>
    <div v-for="content in extraContext?.cart_contents" :key="content.id">
      <!-- 活動 -->
      <PostAdCartPromotionGroup
        ref="storePromotionRef"
        v-if="typeOfPromotions.includes(content?.type)"
        :data="content" 
        :sources="Object.values(state.promotionMap).filter((el) => content?.store_prom_ids.includes(el?.id))"
        :store-data="storeData" 
        :loading="loadingForm" 
        :is_login="is_login" 
        :is-distribute="isDistribute"
        @quick-add="handleQuickAddToCart"
        @show-coin="showCoinLevel"
      />
      <!-- 商品 -->
      <PostAdCartStoreProduct
        ref="storeProductRef"
        v-if="content?.type == 'store_product'"
        :data="content" 
        :store-data="storeData" 
        :sources="content?.store_product_ids.filter((id) => !!state.productMap[id] ).map((id) => state.productMap[id]) || []"
        :loading="loadingForm" 
        :is_login="is_login" 
        :is-distribute="isDistribute"
        class="mt-5"
        @quick-add="handleQuickAddToCart"
        @show-coin="showCoinLevel"
      />

      <!-- 折扣碼 -->
      <PostAdCartCodePromotion
        v-if="content?.type == 'code_promotion'"
        :data="content" 
        :sources="Object.values(state.promotionMap).filter((el) => content?.store_prom_ids.includes(el?.id))"
        :store-data="storeData" 
        :loading="loadingForm" 
        :is_login="is_login" 
        :is-distribute="isDistribute"
        class="mt-5"
      />
    </div>
    
    <!-- 佣金等級 -->
    <PromotionCoinDetail
      v-if="levelState.visible"
      v-model="levelState.visible"
      :product="levelState.item"
      :levels="distributorLevels"
      :distributor="distributor"
    />
    
    <!-- <pre>{{ data }}</pre> -->
  </div>
</template>

<script setup>
import { computed, ref, reactive, watch, toRaw } from 'vue';
import { ElLoading } from 'element-plus';
import { _api_createCartGroup, _api_createCart, _api_getProducts, _api_getPromotions, _api_getPromotionInfo } from "../../api/index.js";
import { 
  notificationErrors, 
  assignCartCount,
  redirectFBMSN, 
  addToCartSuccess,
  dataTranslations as dt, 
} from "../../utils";
import PostAdCartCodePromotion from './PostAdCartCodePromotion.vue';
import PostAdCartPromotionGroup from './PostAdCartPromotionGroup.vue';
import PostAdCartStoreProduct from './PostAdCartStoreProduct.vue';
import PromotionCoinDetail from "../promotions/PromotionCoinDetail.vue"

const props = defineProps({
  data: { type: Object, required: true },
  storeData: { type: Object, required: true },
  distributor: { type: Object, default: () => {} },
  distributorLevels: { type: Array, default: () => [] },
  is_login: { type: Boolean, default: false },
})

const storeId = computed(() => props.storeData?.follow_store_id || props.storeData?.id)
const storeCurrency = computed(() => props.storeData?.currency || "TWD")
const refStoreId = computed(() => props.storeData?.id)
const isDistribute = computed(() => !!props.distributor?.id)
const extraContext = computed(() => props.data?.extra_context || null)
const codeIds = computed(() => {
  let ids = []
  if (extraContext.value?.cart_contents) {
    extraContext.value.cart_contents
      .filter((el) => el?.type === "code_promotion")
      .forEach((el) => {
        ids = _.union(ids, el?.store_prom_ids)
      })
    return ids
  }
  return []
})
const productIds = computed(() => {
  let ids = []
  if (extraContext.value?.cart_contents) {
    extraContext.value.cart_contents
      .filter((el) => el?.type === "store_product")
      .forEach((el) => {
        ids = _.union(ids, el?.store_product_ids)
      })
    return ids
  }
  return []
})

const typeOfPromotions = [
  "distribute_limited_promotion",
  "campaign_promotion",
  "kol_promotion",
];
const promotionIds = computed(() => {
  let ids = []
  if (extraContext.value?.cart_contents) {
    extraContext.value.cart_contents
      .filter((el) => typeOfPromotions.includes(el?.type))
      .forEach((el) => {
        ids = _.union(ids, el?.store_prom_ids)
      })
    return ids
  }
  return []
})

const loadingForm = ref(false)
const storeProductRef = ref()
const storePromotionRef = ref()

const state = reactive({
  cartType: null, // ADD_TO_CART or ADD_TO_CART_GROUP
  productMap: {},
  promotionMap: {},
})
const levelState = reactive({
  item: null,
  visible: false,
})
const showCoinLevel = (item) => {
  // 佣金詳情
  levelState.item = item
  levelState.visible = true
}

const handleQuickAddToCart = async (obj) => {
  const { payloads, redirect, action } = obj
  state.cartType = action
  // console.log("handleQuickAddToCart: ", state.cartType);
  if (!!payloads) {
    addToCartByPayload(payloads, redirect)
  }
}

const addToCartByPayload = async (payloads, redirect = false) => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  let is_success = false
  if (!Array.isArray(payloads)) {
    payloads = [payloads]
  }
  try {
    for (const payload of payloads) {
      try {
        let res = null
        // console.debug("addToCartByPayload: ", payload)
        if (state.cartType == "ADD_TO_CART") {
          res = await _api_createCart(payload)
        } else {
          res = await _api_createCartGroup(payload)
        }
        const eventID = res?.headers?.["x-request-id"] ? res?.headers?.["x-request-id"] : null
        await aibTrackers.addToCart(payload, null, eventID)
        await gtmTrackers.addToCart(payload, null, eventID)
        await fbqTrackers.addToCart(payload, null, eventID)
        await ttqTrackers.addToCart(payload, null, eventID)
        await gtagTrackers.addToCart(payload, null, eventID)
      } catch (err) {
        if (err?.errors) {
          const { type, msg } = err.errors[0]
          if (type == "RequireLoginError") {
            const temp = {"payload": payload, "redirect": redirect}
            localStorage.setItem(state.cartType, JSON.stringify(temp))
          } else {
            localStorage.removeItem(state.cartType)
          }
        }
        throw err
      }
    }
    await assignCartCount(true)
    localStorage.removeItem(state.cartType)
    
    handleCloseItem()
    addToCartSuccess()
    is_success = true
  } catch (err) {
    // console.log("addToCartByPayload", redirect, payloads);
    notificationErrors(err)
  } finally {
    window.ElFullPageLoading && window.ElFullPageLoading.close();
    loadingForm.value = false
    
    if (is_success) {
      if (redirect && !!props.storeData?.fbmsn_base_url) {
        return redirectFBMSN(
          props.storeData?.fbmsn_base_url,
          "/buy_now",
          storeId.value,
          refStoreId.value,
        )
      } else {
        $("#shopping-cart-drawer").click();
      }
    }
  }
}

const handleCloseItem = () => {
  if (storeProductRef.value && Array.isArray(storeProductRef.value)) {
    // console.debug("storeProductRef", toRaw(storeProductRef.value))
    storeProductRef.value.forEach((el) => {
      // 關閉商品組合視窗
      if (el?.modalState?.visible) {
        el.handleCloseItem()
      }
    }) 
  }
  if (storePromotionRef.value && Array.isArray(storePromotionRef.value)) {
    // console.debug("storePromotionRef", toRaw(storePromotionRef.value))
    storePromotionRef.value.forEach((el) => {
      // 關閉商品組合視窗
      if (el?.modalState?.visible) {
        el.handleCloseItem()
      }
    }) 
  }
}

const getStoreProducts = async () => {
  try {
    const params = {
      ids: productIds.value.join(","),
      fields: "price_range,assorts",
      limit: 100,
    }
    const resp = await _api_getProducts(params)
    state.productMap = _.keyBy(resp.data, "id")
    // console.log("productMap: ", state.productMap)
  } catch (error) {
    notificationErrors(error)
  }
}
const availableIds = ref([])
const getStorePromotions = async () => {
  try {
    const ids = [...promotionIds.value, ...codeIds.value]

    // 先檢查可用的活動
    const respList = await _api_getPromotions({ids: ids.join(",")})
    
    if (!respList?.data || !respList?.data.length) {
      return
    }
    availableIds.value = respList?.data.map((el) => el?.id)
    const params = {
      store_id: storeId.value,
      ref_store_id: refStoreId.value,
      fields: "whitelisted_store_products",
    }
    // return
    
    for (const id of availableIds.value) {
      const resp = await _api_getPromotionInfo(id, params)
      if (resp?.id) {
        state.promotionMap[resp?.id] = resp
      }
    }
  } catch (error) {
    notificationErrors(error)
  }
}

const initAdCarts = async () => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  // console.debug("promotionIds: ", promotionIds.value)
  // console.debug("productIds: ", productIds.value)
  try {
    if (promotionIds.value.length || codeIds.value.length) {
      await getStorePromotions()
    }
    if (productIds.value.length) {
      await getStoreProducts()
    }
    const eventID = aibTrackers.generateCustomEventId()
    // console.debug("eventID", eventID)
    initTracker(eventID)
  } catch (error) {
    notificationErrors(error)
    // for test
  } finally {
    window.ElFullPageLoading && window.ElFullPageLoading.close();
  }
}
const initTracker = (eventID = null) => {
  const items = {
    promotions: [],
    products: [],
  }
  if (!!promotionIds.value.length) {
    Object.values(state.promotionMap).forEach((_data) => {
      items.promotions.push(_data)
    })
  }
  if (!!productIds.value.length) {
    Object.values(state.productMap).forEach((_data) => {
      items.products.push(_data)
    })
  }
  // console.debug("initTracker", toRaw(content))
  aibTrackers.viewContentPost({...props.data, items}, eventID);
  gtmTrackers.viewContentPost({...props.data, items}, eventID);
  fbqTrackers.viewContentPost({...props.data, items}, eventID);
  ttqTrackers.viewContentPost({...props.data, items}, eventID);
  gtagTrackers.viewContentPost({...props.data, items}, eventID);
}
watch(
  () => props.data,
  (v) => {
    if (v?.id) {
      // console.debug("promotionIds: ", v)
      initAdCarts()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style>
.swal2-container {
  z-index: 3000;
}
.alerts-border {
  border: 3px #f34770 solid;
  animation: blink 1s;
  animation-iteration-count: 3;
}

@keyframes blink { 50% { border-color:#fff ; }  }

</style>
